import { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { sectionLegacyDefaultV0Schema } from './default';
import { sectionLegacySpecificV0Schema } from './specific';

/**
 * Discriminated union over the envelope's `type` field. Sections without a
 * `type` land on the default branch (its literal is `.optional()`); sections
 * tagged `type: 'specific'` — the header/footer rows — land on the specific one.
 */
const sectionLegacyEntityUnion = z.discriminatedUnion('type', [
    sectionLegacyDefaultV0Schema,
    sectionLegacySpecificV0Schema,
]);

export type LegacyDefaultSection = z.infer<typeof sectionLegacyDefaultV0Schema>;
export type LegacySpecificSection = z.infer<typeof sectionLegacySpecificV0Schema>;
export type LegacySection = LegacyDefaultSection | LegacySpecificSection;

/**
 * Legacy-only entity: the persisted section shape is the only version so far
 * (no v0 redesign yet). Single 'web' variant today.
 */
export const LegacySectionEntitySchema = createLegacyEntitySchema([{ name: 'web', schema: sectionLegacyEntityUnion }]);
